<template>
  <div class="container">
    <div class="row mt-4">
      <div class="col-md-10">
        <p>The competition contains 5 tasks in total:</p>
        <p v-for="(task, i) in $store.state.tasks" :key="i" class="ml-4 my-1">
          {{i+1}}. {{task}}
        </p>
        <p>Participants can pick <strong>1-5</strong> tasks to submit results.</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 ml-auto mr-auto">
        <tabs slot="raw-content" tab-content-classes="tab-content-padding text-center">
          <tab-pane>
            <template slot="label">Task 1</template>
            <task-trigger></task-trigger>
          </tab-pane>
          <tab-pane>
            <template slot="label">Task 2</template>
            <task-poll></task-poll>
          </tab-pane>
          <tab-pane>
            <template slot="label">Task 3</template>
            <task-code></task-code>
          </tab-pane>
          <tab-pane>
            <template slot="label">Task 4</template>
            <task-user></task-user>
          </tab-pane>
          <tab-pane>
            <template slot="label">Task 5</template>
            <task-emotion></task-emotion>
          </tab-pane>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {Card, Tabs, TabPane} from '@/components';
import taskTrigger from "@/index/tasks/taskTrigger";
import taskPoll from "@/index/tasks/taskPoll";
import taskCode from "@/index/tasks/taskCode";
import taskEmotion from "@/index/tasks/taskEmotion";
import taskUser from "@/index/tasks/taskUser";

export default {
  name: "indexTask",
  components: {
    // Card,
    Tabs,
    TabPane,
    taskTrigger,
    taskPoll,
    taskCode,
    taskEmotion,
    taskUser
  },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>